import smoothScroll from 'smooth-scroll';

let options = { 
  speed: 200,
  offset: window.innerWidth >= 1024 ? 100 : 70
};

let scroll = new smoothScroll('a[href*="#"]', options);